import { Observable, helpers } from 'rx';
import { Configure } from 'anuket';
/**
 * Scroll animation shows and hides one row at the time.
 * Starts from beginning when comes to the end.
 * @param  {array}  entries  List of entries to scroll.
 * @param  {object} settings Settings parameters
 * @return {RxJS.Observable}
 */

export function scroll({settings, speed}) {
    let offset = parseInt(settings.results_per_page || 0);
      return Observable.generateWithRelativeTime(
        0,
        (position) => true,
        (position) => position + 1,
        helpers.identity,
        (position) => position == 0 ? 0 : speed * 1000
      ).map((position) => {
        const entriesLength = Configure.getValue('entries').length;
        offset = offset < entriesLength ? offset : entriesLength - 1;
        return offset > entriesLength ? 0 : position % entriesLength;
    })
}

/**
 * Slide animation shows and hides group of entries.
 * Group length is determined with settings.results_per_page
 * @param  {array}  entries  List of entries to scroll.
 * @param  {object} settings Settings parameters
 * @return {RxJS.Observable}
 */

export function slide({settings, defaultTimeout = 5000, speed}) {
    let offset = parseInt(settings.results_per_page || 0);
    let first = true;
    return Observable.generateWithRelativeTime(
      0,
      (position) => true,
      (position) => { 
        const entriesLength = Configure.getValue('entries').length;
        offset = offset < entriesLength ? offset : 10;
        return offset > entriesLength || position + offset >= entriesLength ? 0 : position + offset; 
      },
      helpers.identity,
      (position) => { 
        let slidingSpeed = speed * 1000 * 5;
        defaultTimeout = defaultTimeout ? first ? 100 : slidingSpeed : 0;
        first = false;
        return position == 0 ? defaultTimeout : slidingSpeed}
    );
}



// WEBPACK FOOTER //
// ./streams/animations.js